import { render, staticRenderFns } from "./IOTLanding.html?vue&type=template&id=2bacee08&scoped=true&"
import script from "./IOTLanding.vue?vue&type=script&lang=js&"
export * from "./IOTLanding.vue?vue&type=script&lang=js&"
import style0 from "./IOTLanding.vue?vue&type=style&index=0&id=2bacee08&lang=scss&scoped=true&"
import style1 from "./IOTLanding.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bacee08",
  null
  
)

export default component.exports